import React, { ChangeEvent, useCallback } from 'react';
import ChevronLeft from '../icons/ChevronLeft';
import './style.scss';

export type SourceOption = {
  value: string;
  body: string;
  disabled?: boolean;
};

export type PickerProps = {
  options: SourceOption[];
  value: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
};

const Picker: React.FC<PickerProps> = ({
  options,
  value,
  onChange,
  className,
}) => {
  const renderSourceOption = useCallback<(option: SourceOption) => JSX.Element>(
    ({ value, disabled = false, body }) => (
      <option disabled={disabled} value={value}>
        {body}
      </option>
    ),
    []
  );

  return (
    <div className={`dropdown-legacy ${className}`}>
      <select
        value={value}
        onChange={onChange}
        className="dropdown-select-legacy"
      >
        {options?.map(renderSourceOption)}
      </select>
      <ChevronLeft className="dropdown-legacy__chevron" />
    </div>
  );
};

export default React.memo(Picker);
